/**
 * Thin client for road_fighter_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'road_fighter';

export const ROAD_FIGHTER_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.road_fighter?.API_BASE || '')
    : '/road';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Road Fighter GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createRoadFighterSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${ROAD_FIGHTER_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveRoadFighterSession(sessionId, action = 'tick') {
    const res = await fetch(`${ROAD_FIGHTER_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
    });
    return parseJson(res);
}

export async function deleteRoadFighterSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${ROAD_FIGHTER_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

/** Map GM snake_case payload → FE view state used by RoadFighterScene. */
export function gmToRoadView(data) {
    const reward = data.level_clear_reward;
    const level = Number(data.level) || 1;
    let lastReward = null;
    if (reward && typeof reward === 'object') {
        lastReward = {
            fuelGain: reward.fuel_gain ?? reward.fuelGain ?? 0,
            repair: reward.repair ?? 0,
            bonusMeters: reward.bonus_meters ?? reward.bonusMeters ?? 0,
            fuelAfter: reward.fuel_after ?? reward.fuelAfter,
            damageAfter: reward.damage_after ?? reward.damageAfter,
            completedLevel: level,
            nextName: reward.next_name || reward.nextName,
        };
    }
    return {
        player: data.player || { lane: 1, distance: 0, speed: 0, damage: 0, fuel: 100 },
        obstacles: Array.isArray(data.obstacles) ? data.obstacles : [],
        fuelPacks: Array.isArray(data.fuel_packs) ? data.fuel_packs : [],
        healthPacks: Array.isArray(data.health_packs) ? data.health_packs : [],
        level,
        tick: data.tick || 0,
        campaignDistance: Number(data.campaign_distance) || 0,
        score: typeof data.score === 'number' ? data.score : 0,
        isFinished: Boolean(data.is_finished),
        isCrashed: Boolean(data.is_crashed),
        isOutOfFuel: Boolean(data.is_out_of_fuel),
        skidding: Boolean(data.skidding),
        levelClear: Boolean(data.level_clear),
        lastReward,
        message: data.message || '',
        trackLength: Number(data.track_length) || 1600,
        maxSpeed: Number(data.max_speed) || 360,
    };
}
